module.exports = __webpack_public_path__ + "445dac15425d169c68c2b028952c1cac.svg";